import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { document } from 'src/api';
import {
  // Breadcrumb,
  Button
} from 'antd';

const css = require('./footer.scss');

/** Redux接口 */
interface IReduxStatePart {

}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
  status: any;
  update: any;
  id: string;
}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))

export default class Header extends UIBasic<IProps, ModulesState> {

  constructor(props: IProps) {
    super(props, ModulesAction);
  }

  render() {
    return (
      <div className={css['footer']}>
        <Button onClick={this.goBack} className="kts-but-default">返回</Button>
        {ModulesAction.allowedTargetStatus(this.props.id, this.props.status)}
      </div>
    );
  }

  private goBack = () => {
    this.props.history.goBack();
  }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/UI.footer.tsx